module.exports = __webpack_public_path__ + "img/screen-wizard.8c786a7e.png";